var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-wall"},_vm._l((_vm.items),function(item){return _c('employee-item',{key:item.id,attrs:{"item":item,"is-show-all":_vm.isShowAll}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }